import {ElementRef} from '@angular/core';

export class PositionElement {
  private x: number;
  private y: number;
  private width: number;
  private height: number;
  private top: number;
  private left: number;
  private right: number;
  private bottom: number;

  constructor(element: any) {
    const parentPosition = this.getElementPosition(element);
    const parentTopPosition = parentPosition === null ? 0 : parentPosition.top;

    const rect = element.getBoundingClientRect();
    this.x = rect.x;
    this.y = rect.y +  window.scrollY;
    this.width = rect.width;
    this.height = rect.height;
    this.top = rect.top - parentTopPosition;
    this.left = rect.left;
    this.right = rect.right;
    this.bottom = rect.bottom;
    // tslint:disable-next-line:max-line-length
    console.log('PositionElement x:[' + this.x + '] y:[' + this.y + '] width:[' + this.width + '] height:[' + this.height + '] top:[' + this.top + '] left:[' + this.left + '] right:[' + this.right + '] bottom:[' + this.bottom + ']');

  }

  /**
   * Get the position of parent the element with display = relative
   */
  private getElementPosition(element: ElementRef): DOMRect {
    // @ts-ignore
    const parent = element.parentElement;
    if (parent === null) {
      return null;
    }
    const displayType = window.getComputedStyle(parent, null).position;
    if (displayType === 'relative') {
      return parent.getBoundingClientRect();
    } else {
      return this.getElementPosition(parent);
    }
  }
  get X(): number {
    return this.x;
  }
  get Y(): number {
    return this.y;
  }
  get Width(): number {
    return this.width;
  }
  get Height(): number {
    return this.height;
  }
  get Top(): number {
    return this.top;
  }
  get Left(): number {
    return this.left;
  }
  get Right(): number {
    return this.right;
  }
  get Bottom(): number {
    return this.bottom;
  }
}
